import { render } from "./LimitationProfileDialog.vue?vue&type=template&id=035d5678"
import script from "./LimitationProfileDialog.vue?vue&type=script&lang=js"
export * from "./LimitationProfileDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__